// extracted by mini-css-extract-plugin
export var quantityInput = "_oa-0";